<template>
  <div class="warning_cont">
    <div class="warning_box">
      <div class="warning_icon">
        <img src="../../../assets/分组 6 (1).png" alt="" />
      </div>
      <div class="warning_content">
        <div class="text">
          <div class="title">Alarm</div>
          <el-carousel height="50px" direction="vertical" :autoplay="true" indicator-position="none"
            v-if="warninglist.length > 0">
            <el-carousel-item v-for="item in warninglist" :key="item">
              <div style="display: flex" class="content">
                <div class="content_cont">
                  【{{ item.type_name }}】
                  <span style="color: rgba(189, 89, 87, 1)" class="content_text">
                    {{ item.noti_detail }}
                  </span>
                </div>
                <div class="content_time">
                  {{ item.createtime }}
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div v-else class="nowarning">No Alarm in Current Module</div>
          <div class="content"></div>
        </div>
        <div class="more">
          <div class="more_box" @click="gotomore()">View All</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// import config from "@/utils/config";

export default {
  data() {
    return {
      allControlData: null,
      openIndex: null,
      queryInfo: {
        warningdes: "",
        states: "",
        modules: "",
        pagenum: 1,
        pagesize: 6,
      },
      ignoreRequest: {
        id: "",
        deal: null,
        reason: "",
      },
      finishRequest: {
        id: "",
        deal: null,
        reason: "",
      },
      warninglist: [],
    };
  },
  mounted() {
    this.openIndex = this.$route.query.index;
    this.getAlertAllData();
  },
  methods: {
    async getAlertAllData() {
      this.queryInfo.modules = this.openIndex;
      console.log(this.queryInfo.modules);
      const { data: res } = await this.$http.get(
        "/alarm/record/list",
        {
          params: this.queryInfo,
        }
      );
      if (res.code !== 200) {
        return this.$message.error("error");
      }
      this.warninglist = [];
      for (let i = 0; i < res.data.data.length; i++) {
        if (res.data.data[i].status == 0) {
          this.warninglist.push(res.data.data[i]);
        }
      }
      console.log(res.data);
    },
    gotomore() {

      if (this.warninglist.length > 0) {
        this.$router.push({
          path: "/WarningCenter",
        });
      } else {
        this.$router.push({
          path: "/WarningCenter",
        });
      }
    },
    cbrBtnStyle(index) {
      if (this.allControlData.result.pool[index].flag == true) {
        return { backgroundColor: "#1890ff", color: "fff" };
      } else {
        return { backgroundColor: "#b8b8b8", color: "fff" };
      }
    },

    async IgnoreWarnings(item) {
      console.log(item);
      this.ignoreRequest.deal = 0;
      this.ignoreRequest.id = item.id;
      if (this.ignoreRequest.reason === "") {
        this.ignoreRequest.reason = "No operating instructions";
      }
      const { data: res } = await this.$http.post(
        "/warning/deal",
        this.ignoreRequest
      );

      if (res.meta.status == 200) {
        this.$message.success(res.meta.msg);
      }
      this.getAlertAllData();
    },

    async warningFinish(item) {
      console.log(item);
      this.finishRequest.deal = 1;
      this.finishRequest.id = item.id;
      this.finishRequest.reason = this.ignoreRequest.reason;
      if (this.finishRequest.reason === "") {
        this.finishRequest.reason = "No operating instructions";
      }
      const { data: res } = await this.$http.post(
        "/warning/deal",
        this.finishRequest
      );
      if (res.meta.status == 200) {
        this.$message.success(res.meta.msg);
      }
      this.getAlertAllData();
    },
  },
};
</script>

<style lang="scss" scoped>
.warning_cont {
  .warning_box {
    display: flex;
    align-items: center;
    left: 772.2px;
    top: 117px;
    width: 1690px;
    height: 145.6px;
    opacity: 1;
    border-radius: 26px;
    background: #212121FF;
    box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);

    .warning_icon {
      margin-left: 33.8px;
      margin-right: 12px;
      left: 806px;
      top: 149.5px;
      width: 80.6px;
      height: 80.6px;
      opacity: 1;

      img {
        width: 100%;
      }
    }

    .warning_content {
      width: 1530px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title {
        margin-top: 14px;
        margin-bottom: 14px;
        margin-left: 14px;
        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 33.88px;
        color: rgba(97, 97, 97, 1);
      }

      .nowarning {
        margin-left: 15px;
        width: 662px;
        height: 50px;
        font-size: 20.8px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24.38px;
        color: rgba(158, 158, 158, 1);
        text-align: left;
        vertical-align: top;
      }

      .content {
        min-width: 1200px;
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(97, 97, 97, 1);
      }

      .content_cont {
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }

      .content_time {
        cursor: pointer;
        margin-left: 28px;
        width: 400px;
        font-size: 20px;
        font-weight: 400;
        letter-spacing: 0px;
        color: rgba(158, 158, 158, 1);
        text-align: left;
        vertical-align: top;
      }

      .btn {
        display: flex;

        .pass {
          width: 60px;
          cursor: pointer;
          font-size: 20px;
          font-weight: 400;
          letter-spacing: 0px;
          color: rgba(243, 146, 146, 1);
          text-align: left;
          vertical-align: top;
        }

        .finish {
          width: 60px;
          cursor: pointer;
          font-size: 20px;
          font-weight: 400;
          letter-spacing: 0px;
          color: rgba(39, 111, 183, 1);
          text-align: left;
          vertical-align: top;
        }
      }

      .more {
        .more_box {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          left: 2229.5px;
          top: 149.5px;
          width: 195px;
          height: 80.15px;
          opacity: 1;
          border-radius: 172.9px;
          background: rgba(51, 51, 51, 1);
          color: rgba(204, 204, 204, 1);
          font-size: 23.4px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 33.88px;
          text-align: left;
          vertical-align: top;
        }
      }

      .history_box {
        display: flex;
        width: 1689px;
        height: 439px;
        opacity: 1;
        border-radius: 39.01px;
        background: rgba(26, 26, 34, 1);
        box-shadow: 0px 2.6px 9.1px rgba(0, 0, 0, 0.05);
      }
    }
  }
}
</style>
